<template>
    <div>
      <schoolFilter ref="schoolFilterData" @getCustomerId = "getCustomerId"/>
      <div class="cstm-tab-holder">
        <!-- <div  v-if="typeOfUser === 'Children' || typeOfUser === ''" class="cstm-unique-tab flex mb-4">
        <div class="flex flex-wrap justify-between items-center">
          <div class="inline-flex flex-wrap justify-center items-center p-2">
            <vs-button class="includeIcon includeIconOnly" @click="FilterWithSchool">Go</vs-button>

            <vs-tooltip text="Reset">
              <vs-button type="border" icon-pack="feather" @click="resetFilter" icon="icon-refresh-ccw" class="ml-2"></vs-button>
            </vs-tooltip>
          </div>
        </div>
        </div> -->
        <div  v-if="typeOfUser === 'Children' || typeOfUser === ''" class="cstm-unique-tab flex mb-4" :class="{disableTabName: kanbanShow}">
          <div v-if="(taskPermission === 0 && typeOfUser === 'Children') || typeOfUser === ''" class="tab-name" :class="{'activeTab': task}" @click="tab('task')">
            Tasks
          </div>
          <div v-if="(projectPermission === 0 && typeOfUser === 'Children') || typeOfUser === ''" class="tab-name" :class="{'activeTab': projects}" @click="tab('projects')">
            Projects
          </div>
        </div>
        <div class="inner-cstm-tab-text">
          <div v-if="(task && typeOfUser === 'Children' && taskPermission === 0) || (task && typeOfUser === '')">
            <vs-button class="block ml-auto" v-if="kanbanShow"  @click="kanbanview">Live Task</vs-button>
            <vs-button class="block ml-auto" v-if="!kanbanShow && limitedTableLiveList.length !== 0" @click="kanbanview">Kanban</vs-button>
            <div v-if="!kanbanShow">
              <ag-grid-vue
                ref="agGridTable"
                :components="components"
                :gridOptions="gridOptions1"
                class="ag-theme-material w-100 ag-grid-table task-ag-grid"
                :columnDefs="columnDefs1"
                :defaultColDef="defaultColDef"
                :rowData="limitedTableLiveList"
                rowSelection="multiple"
                colResizeDefault="shift"
                :animateRows="true"
                :floatingFilter="false"
                :pagination="true"
                :paginationPageSize="paginationPageSize"
                :suppressPaginationPanel="true"
                @cell-value-changed="onCellValueChanged"
                @row-selected="CellvalueSelectDeselect2"
                :enableRtl="$vs.rtl"
                @cell-clicked="cellSingleClickedLive"
                @grid-ready="onGridReady">
              </ag-grid-vue>
            </div>
            <kanban v-if="kanbanShow" :liveData="UpdatedListOfLiveTask" ></kanban>
          </div>
          <div v-if="projects">
            <ProjectListing ref="forSchoolFilter" :customer_id="customer_id"></ProjectListing>
          </div>
        </div>
      </div>
        <vs-row v-if="!kanbanShow && !projects && typeOfUser === 'Children' && taskPermission === 0"  class="mt-2" vs-type="flex" vs-justify="space-between">
      <vs-col
        vs-xs="12"
        vs-sm="6"
        vs-lg="4"
        vs-type="flex"
        vs-justify="start"
        vs-align="center"
      >
        <!-- page limit select view -->
        <span style="font-size: 12px">
          Show
          <select
            v-model="pageLimitSet"
            style="
              background: #fff !important;
              height: 40px;
              width: 70px;
              font-size: 12px;
            "
            class="form-control vs-select--input vs-select--input-con"
          >
            <option
              v-for="(option, index) of pageLimitOPtion"
              :key="index"
              :value="option.value"
              :label="option.value"
              class="vs-select--options"
            >
              {{ option.value }}
            </option></select
          >entry
        </span>
      </vs-col>
       <vs-col vs-xs="12" vs-sm="6" vs-lg="8">
        <pagination
          style="float: right"
          :meta="meta_task_data"
          @page-change="handlePageChange"
        />
      </vs-col>
    </vs-row>
    <vs-row v-if="!kanbanShow && !projects && typeOfUser === ''"  class="mt-2" vs-type="flex" vs-justify="space-between">
      <vs-col
        vs-xs="12"
        vs-sm="6"
        vs-lg="4"
        vs-type="flex"
        vs-justify="start"
        vs-align="center"
      >
        <!-- page limit select view -->
        <span style="font-size: 12px">
          Show
          <select
            v-model="pageLimitSet"
            style="
              background: #fff !important;
              height: 40px;
              width: 70px;
              font-size: 12px;
            "
            class="form-control vs-select--input vs-select--input-con"
          >
            <option
              v-for="(option, index) of pageLimitOPtion"
              :key="index"
              :value="option.value"
              :label="option.value"
              class="vs-select--options"
            >
              {{ option.value }}
            </option></select
          >entry
        </span>
      </vs-col>
       <vs-col vs-xs="12" vs-sm="6" vs-lg="8">
        <pagination
          style="float: right"
          :meta="meta_task_data"
          @page-change="handlePageChange"
        />
      </vs-col>
    </vs-row>

        
    </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import CellRendererActions from './CellRendererActions.vue'
import ReferenceAction from './ReferenceAction.vue'
import StatusCell from './statuscell'
import kanban from './kanban-view.vue'
import ProjectListing from '../project-listing.vue'
import Pagination from '@/components/common/pagination'
import { taskUpdate, taskTemplateUpdate, taskTemplateDelete, taskDelete } from '@/api/task-project.js'
import { mapGetters, mapActions } from 'vuex'
import { Project } from '../mixins/project.js'
import allServices from '@/api/auth/auth'
import schoolFilter from '@/components/schoolFilter/schoolFilter'

export default {
  name: 'task-table',
  components: {
    AgGridVue,
    CellRendererActions,
    ReferenceAction,
    StatusCell,
    ProjectListing,
    kanban,
    Pagination,
    schoolFilter
  },
  props: ['UpdatedListOfLiveTask', 'UpdatedListOfTask', 'meta_template_data', 'meta_task_data'],
  mixins: [Project],
  data () {
    return {
      liveTaskData2: this.UpdatedListOfLiveTask,
      taskData2: this.UpdatedListOfTask,
      isRowSelected: false,
      primary: '#41cfdd',
      kanbanShow: false,
      searchQuery: '',
      gridOptions: {},
      gridOptions1: {
        rowHeight: 80
      },
      maxPageNumbers: 7,
      gridApi1: null,
      gridApi: null,
      defaultColDef: {
        sortable: true,
        editable: true,
        resizable: true,
        suppressMenu: true
      },
      components: {
        CellRendererActions,
        ReferenceAction,
        StatusCell
      },
     
      columnDefs1: [
        {
          headerName: '',
          width: 50,
          field: 'isSelected',
          filter: true,
          checkboxSelection: true,
          editable: false,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true
        },
        {
          headerName: '#',
          field: 'row_index',
          filter: true,
          width: 60,
          resizable: true,
          editable: false
        },
        {
          headerName: 'Reference Id',
          field: 'reference_id',
          filter: true,
          minWidth: 60,
          resizable: true,
          editable: false,
          cellRendererFramework: 'ReferenceAction'
        },
        {
          headerName: 'Task Name',
          field: 'name',
          minWidth: 175,
          editable: false,
          filter: true,
          cellStyle: { color: 'blue' }
        },
        {
          headerName: 'Task Details',
          field: 'details',
          filter: true,
          editable: false,
          minWidth: 175
        },
        {
          headerName: 'Priority',
          field: 'task_priority.level',
          minWidth: 250,
          filter: true,
          editable: false
        },
        // {
        //   headerName: 'Status',
        //   field: 'status.id',
        //   minWidth: 250,
        //   filter: true,
        //   editable: false,
        //   cellRendererFramework: StatusCell
        // },
       
        {
          headerName: 'Deadline',
          field: 'due_date',
          minWidth: 175,
          filter: true
        }
      ],
      task: true,
      projects: false,
      taskPermission: 1,
      projectPermission: 1,
      typeOfUser: '',
      customer_id: localStorage.getItem('customer_id')
    }
  },
  computed: {
    ...mapGetters([
      'get_task_deleted_id',
      'get_task_deleted_live_id',
      'get_task_added_id'
    ]),
    limitedTableLiveList () {
      return this.UpdatedListOfLiveTask
    }
  },
  watch: {
    get_task_deleted_id () {
      if (this.get_task_deleted_id) {
        const table = this.UpdatedListOfTask
        const dlt_id = table.findIndex(
          (item) => item.id === this.get_task_deleted_id
        )
        table.splice(dlt_id, 1)
        table.map((row, index) => {
          row.row_index = index + 1
        })
        this.UpdatedListOfTask = table
      }
    },

    get_task_deleted_live_id () {
      if (this.get_task_deleted_live_id) {
        const table = this.UpdatedListOfLiveTask
        const dlt_id = table.findIndex(
          (item) => item.id === this.get_task_deleted_live_id
        )
        table.splice(dlt_id, 1)
        table.map((row, index) => {
          row.row_index = index + 1
        })
        this.UpdatedListOfLiveTask = table
      }
    },
    pageLimitSet () {
      this.handlePageChange(1)
    }
  },
  mounted () {
    if (localStorage.getItem('typeOfUser') === 'Children') {
      this.typeOfUser = 'Children'
      this.accessModule()
    }
    
    this.gridApi = this.gridOptions.api
    this.gridApi1 = this.gridOptions1.api
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }
    this.customer_id = this.$refs.schoolFilterData.$data.schoolId
  },
 
  methods: {
    ...mapActions([
      'SET_DELETE_ID',
      'SET_DELETE_LIVE_ID',
      'SET_ADD_ID'
    ]),
    getCustomerId (customerId) {
      this.customer_id = customerId
      // alert("SDSDSDSDSD")
      if (this.task) {
        this.handlePageChange(1)
      } else {
        this.$refs.forSchoolFilter.ProjecthandlePageChange(1)
      }
    },
    onGridReady () {
    // this.gridOptions.api.sizeColumnsToFit()
      this.gridOptions1.api.sizeColumnsToFit()
    },
    FilterWithSchool () {
      this.customer_id = this.$refs.schoolFilterData.$data.schoolId
      if (this.task) {
        this.handlePageChange(1)
      } else {
        this.$refs.forSchoolFilter.ProjecthandlePageChange(1)
      }
    },
    resetFilter () {
      this.$refs.schoolFilterData.$data.schoolId = null
    },
    kanbanview () {
      this.kanbanShow = !this.kanbanShow
    },
    async accessModule () {
      try {
        const { data } = await allServices.fetch_accessible_module_list()
        const taskFilter = data.data.list.filter(function (currentElement) {
          return currentElement.module_name === 'Tasks' 
    && currentElement.has_permission === 1
        })
        if (taskFilter.length === 1) {
          this.taskPermission = 0
        }
        const projectFilter = data.data.list.filter(function (currentElement) {
          return currentElement.module_name === 'Projects' 
    && currentElement.has_permission === 1
        })
        if (projectFilter.length === 1) {
          this.projectPermission = 0
          this.tab('projects')
        }
        
      } catch (api_error) {
        console.log(api_error.message)
      }
    },
    tab (type) {
      if (type === 'task') {
        this.task = true
        this.projects = false
      } else {
        this.task = false
        this.projects = true
      }
    },

    openModalSectionLive (params) {
      this.$emit('openModalSectionLive', params)
    },
  
    cellSingleClickedLive (params) {
      if (params.column.colId === 'name') {
        this.openModalSectionLive(params)
      }
    },
    handlePageChange (page) {
      const queryPayload = Object.assign({}, this.$route.query)
      queryPayload.page = page
      queryPayload.limit = this.pageLimitSet
      queryPayload.customer_id = this.$refs.schoolFilterData.$data.schoolId
      const pageScroll = document.documentElement.scrollTop
      this.$router
        .replace({ path: '/tasks-projects', query: queryPayload })
        .catch(() => {}).then(() => {
          document.documentElement.scrollTop = pageScroll
        })
      this.passEvent(queryPayload)
    }, 
    passEvent (page) {
      this.$emit('passEvent', page)
    },
    CellvalueSelectDeselect () {
      this.gridApi = this.gridOptions.api
      const selectedNodes = this.gridApi.getSelectedNodes()
      // console.log(selectedNodes)
      if (selectedNodes) {
        const selecttedNode = this.gridApi.getSelectedNodes()
        const selectedRows = selecttedNode.map((node) => node.data)
        if (selectedRows.length > 1) {
          this.isRowSelected = true
        } else {
          this.isRowSelected = false
        }
      } else {
        this.isRowSelected = false
      }
    },
    CellvalueSelectDeselect2 () {
      this.gridApi1 = this.gridOptions1.api
      const selectedNodes = this.gridApi1.getSelectedNodes()
      // console.log(selectedNodes)
      if (selectedNodes) {
        const selecttedNode = this.gridApi1.getSelectedNodes()
        const selectedRows = selecttedNode.map((node) => node.data)
        if (selectedRows.length > 1) {
          this.isRowSelected = true
        } else {
          this.isRowSelected = false
        }
      } else {
        this.isRowSelected = false
      }
    },

    getSelectedRows () {
      const selectedNodes = this.gridApi.getSelectedNodes()
      const selectedData = selectedNodes.map((node) => node.data)
      return selectedData
    },
    getSelectedRows2 () {
      const selectedNodes = this.gridApi1.getSelectedNodes()
      const selectedData = selectedNodes.map((node) => node.data)
      return selectedData
    },

    onCellValueChanged (params) {
      if (this.task === true) {
        const data = []
        data.colId = params.column.getId()
        data.task_id = params.data.id
        if (data.colId === 'name') {
          data.fieldvalue = params.data.name
          data.colId = 'name'
          if (data.fieldvalue === '') {
            this.$vs.notify({
              title: 'Warning',
              text: 'Name field must be greater than 0',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
              time: 8000,
              position: 'top-center'
            })
            return false
          }
        } else if (data.colId === 'details') {
          data.fieldvalue = params.data.details
          data.colId = 'details'
          if (data.fieldvalue === '') {
            this.$vs.notify({
              title: 'Warning',
              text: 'Details field must be greater than 0',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
              time: 8000,
              position: 'top-center'
            })
            return false
          }
        }
        this.update_user(data)
      } else {
        const data = []
        data.colId = params.column.getId()
        data.task_id = params.data.id

        if (data.colId === 'name') {
          data.fieldvalue = params.data.name
          data.colId = 'name'
          if (data.fieldvalue === '') {
            this.$vs.notify({
              title: 'Warning',
              text: 'Name field must be greater than 0',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
              time: 8000,
              position: 'top-center'
            })
            return false
          }
        } else if (data.colId === 'details') {
          data.fieldvalue = params.data.details
          data.colId = 'details'
          if (data.fieldvalue === '') {
            this.$vs.notify({
              title: 'Warning',
              text: 'Details field must be greater than 0',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
              time: 8000,
              position: 'top-center'
            })
            return false
          }
        }
        this.update_user(data)
      }
  
      
    },
    async update_user (data) {
      if (this.task === true) {
        const task_id = data.task_id
        const payload = {
          updateField: {
            [data.colId]: data.fieldvalue
          }
        }
        try {
          console.log(payload)
          const { data } = await taskUpdate(
            localStorage.getItem('customer_id'),
            task_id,
            payload
          )
          console.log(data)
          this.$vs.notify({
            title: 'Success',
            text: 'Task Updated Successfully',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
        } catch (api_error) {
          console.log(api_error.message)

          this.$vs.notify({
            title: 'Warning',
            text: api_error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            time: 3000,
            position: 'top-center'
          })
        }
      } else {
        const task_id = data.task_id
        const payload = {
          updateField: {
            [data.colId]: data.fieldvalue
          }
        }
        try {
          console.log(payload)
          const { data } = await taskTemplateUpdate(
            localStorage.getItem('customer_id'),
            task_id,
            payload
          )
          console.log(data)
          this.$vs.notify({
            title: 'Success',
            text: 'Task Updated Successfully',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
        } catch (api_error) {
          console.log(api_error.message)

          this.$vs.notify({
            title: 'Warning',
            text: api_error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            time: 3000,
            position: 'top-center'
          })
        }
      }
    },

    handleBulkDelete () {
      if (this.task === true) {
        const BulkSelected = this.getSelectedRows2()
        const deleting_ids = []
        for (let i = 0; i < BulkSelected.length; i++) {
          deleting_ids.push(BulkSelected[i].id)
        }
        const payload = {
          deleteFields: deleting_ids
        }
        taskDelete(localStorage.getItem('customer_id'), payload)
          .then((data) => {
            console.log(data)
            const table = this.UpdatedListOfLiveTask
            for (const delete_id_itr of deleting_ids) {
              for (let i = 0; i < table.length; i++) {
                console.log(i)
                if (delete_id_itr === table[i].id) {
                  table.splice(i, 1)
                }
              }
            }
            table.map((row, index) => {
              row.row_index = index + 1
            })
            this.UpdatedListOfLiveTask = table
            this.isRowSelected = true
            this.$vs.notify({
              title: 'Success',
              text: 'Bulk Deletion Successfull',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success'
            })
          })
          .catch((e) => {
            this.$vs.notify({
              title: 'Warning',
              text: e.data.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })
            console.log(e.data)
          })
      } else {
        const BulkSelected = this.getSelectedRows()
        const deleting_ids = []
        for (let i = 0; i < BulkSelected.length; i++) {
          deleting_ids.push(BulkSelected[i].id)
        }
        const payload = {
          deleteFields: deleting_ids
        }
        taskTemplateDelete(localStorage.getItem('customer_id'), payload)
          .then((data) => {
            console.log(data)
            const table = this.UpdatedListOfTask
            for (const delete_id_itr of deleting_ids) {
              for (let i = 0; i < table.length; i++) {
                console.log(i)
                if (delete_id_itr === table[i].id) {
                  table.splice(i, 1)
                }
              }
            }
            table.map((row, index) => {
              row.row_index = index + 1
            })
            this.UpdatedListOfTask = table
            this.isRowSelected = true
            this.$vs.notify({
              title: 'Success',
              text: 'Bulk Deletion Successfull',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success'
            })
          })
          .catch((e) => {
            this.$vs.notify({
              title: 'Warning',
              text: e.data.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })
          })
      }
    }
  }
}
</script>

<style>
  .ag-theme-material {
    min-height: 300px;
  }
  .ag-theme-material.task-ag-grid  .ag-ltr .ag-cell {
    display: flex;
    align-items: center;
  }
  .disableTabName .tab-name {
    visibility: hidden;
  }
</style>